import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';
import { CompanyAndAgent } from '~/components/connections/types';

type IndexParams = {
  nmls: string;
  page: number;
  period: Period;
  sort_field: string;
  order: Order;
};

type IndexResponse = {
  data: {
    companies: CompanyAndAgent[];
    companies_count: number;
    companies_volume: number;
    companies_units: number;
  };
};

export const index = async (allParams: IndexParams) => {
  const { nmls, sort_field, order, ...params } = allParams;
  return apiClient.get<IndexResponse>(
    `/loan_officers/${nmls}/tpo_companies?sort[field]=${sort_field}&sort[order]=${order}`,
    { params }
  );
};
